import React, { useState, useEffect } from 'react';
import { useGetUser, useSetUser } from '../../context/userContext';
import editUser from '../../api/editUser';

const Hobby = () => {
  const user = useGetUser();
  const setUser = useSetUser();
  const [edit, setEdit] = useState(false);
  const [userCopy, setUserCopy] = useState(user);

  useEffect(() => {
    setUserCopy(user);
  }, [user]);

  return (
    <div className="row mycard">
      <div className="col col-12">
        {edit ? <EditInfo userCopy={userCopy} setUserCopy={setUserCopy} user={user} setUser={setUser} setEdit={setEdit} /> : <Info userCopy={userCopy} setEdit={setEdit} />}
      </div>
    </div>
  );
};

export default Hobby;

const Info = ({ userCopy, setEdit }) => {
  return (
    <>
      <h2 className="heading">
        <span>
          <small>Hobby</small>
        </span>
        <button className="btn btn-sm profile-btn" onClick={() => setEdit(true)}>
          <i className="bi bi-pencil-fill"></i> Edit
        </button>
      </h2>
      <div className="content mx-5">
        <div className="main">
          <div className="row">
            {!userCopy.hobby && (
              <div className="col col-12">
                <span className="lead">No details has been provided yet.</span>
              </div>
            )}
            <div className="col col-12">
              <p>
                <small style={{ whiteSpace: 'pre-line' }}>{userCopy.hobby}</small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const EditInfo = ({ userCopy, setUserCopy, user, setUser, setEdit }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    editUser(userCopy, setUser);
    setEdit(false);
  };

  const handleCancel = () => {
    setUserCopy(user);
    setEdit(false);
  };

  return (
    <>
      <h2 className="heading">
        <small>Hobby</small>
        <span></span>
      </h2>
      <div className="content mx-5">
        <div className="main">
          <form className="row g-3" onSubmit={(e) => handleSubmit(e)}>
            <div className="col-12 col-md-12">
              <div className="form-floating">
                <textarea
                  className="form-control"
                  placeholder=""
                  style={{ height: '100px' }}
                  value={userCopy.hobby}
                  onChange={(e) => {
                    setUserCopy((prev) => {
                      return { ...prev, hobby: e.target.value };
                    });
                  }}
                />
                <label htmlFor="summary">How do you spend your free time?</label>
              </div>
            </div>

            <div className="col-12 text-end">
              <button type="button" className="btn profile-btn inver mb-1" onClick={handleCancel}>
                Cancel
              </button>
              <button type="submit" className="btn profile-btn mb-1 ms-3">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
